import * as React from "react";
const SvgRightMiniArrow = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 7, height: 12, fill: "none", viewBox: "0 0 7 12", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M1.333.5.158 1.793 3.975 6 .158 10.208 1.333 11.5l5-5.5z" }));
export default SvgRightMiniArrow;
